window.OoniQuizResults = {
  localProducts: {},

  clean(value) {
    const raw = (value || "").replace(/\+/g, " ").trim();
    if (!raw) return "";

    // Quiz Kit answer labels can contain formatting such as <b>...</b>.
    // Results-page values come from URL parameters, so normalize them to
    // plain text before they are used for matching or rendered on the page.
    let text = raw;
    for (let i = 0; i < 2; i += 1) {
      const doc = new DOMParser().parseFromString(text, "text/html");
      const next = doc.body.textContent || "";
      if (next === text) break;
      text = next;
    }

    return text
      .replace(/\u00a0/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  },

  lower(value) {
    return this.clean(value).toLowerCase();
  },

  mapFuel(value) {
    const v=this.lower(value);
    if (v.includes("gas") && !v.includes("both")) return "q1_fuel_a1";
    if (v.includes("wood") || v.includes("charcoal")) return "q1_fuel_a2";
    if (v.includes("both") || v.includes("flexibility")) return "q1_fuel_a3";
    return "";
  },

  mapGasSize(value) {
    const v=this.lower(value);
    if (!v) return "";
    if (v.includes("12–14") || v.includes("12-14") || v.includes("compact")) return "q2_gas_size_a1";
    if (v.includes("16–18") || v.includes("16-18") || v.includes("roomier")) return "q2_gas_size_a2";
    if (v.includes("20+") || v.includes("go big") || v.includes("multiple pizzas")) return "q2_gas_size_a3";
    return "";
  },

  mapMultiSize(value) {
    const v=this.lower(value);
    if (!v) return "";
    if (v.includes("compact") || v.includes("12 inches")) return "q2_multi_size_a1";
    if (v.includes("roomier") || v.includes("16 inches")) return "q2_multi_size_a2";
    return "";
  },

  mapUse(value) {
    const v=this.lower(value);
    if (!v) return "";
    if (v.includes("on the go") || v.includes("camping") || v.includes("trips")) return "q3_home_a1";
    if (v.includes("moving it around at home") || v.includes("patio") || v.includes("deck") || v.includes("backyard")) return "q3_home_a2";
    if (v.includes("dedicated outdoor") || v.includes("larger outdoor cooking")) return "q3_home_a3";
    if (v.includes("move it around") || v.includes("take it on trips")) return "q3_home_a1";
    if (v.includes("mostly in one spot")) return "q3_home_a2";
    if (v.includes("larger outdoor")) return "q3_home_a3";
    return "";
  },

  mapValue(value) {
    const v=this.lower(value);
    if (!v) return "";
    if (v.includes("simple") || v.includes("value-focused")) return "q5_value_a1";
    if (v.includes("newer performance") || v.includes("convenience") || v.includes("spend more")) return "q5_value_a2";
    if (v.includes("premium") || v.includes("maximum space")) return "q5_value_a3";
    return "";
  },

  getState() {
    const p=new URLSearchParams(window.location.search);
    const raw={
      fuel:this.clean(p.get("fuel")),
      gasSize:this.clean(p.get("gas_size")),
      multiSize:this.clean(p.get("multi_size")),
      use:this.clean(p.get("use")),
      cook:this.clean(p.get("cook")),
      pizzaStyle:this.clean(p.get("pizza_style")),
      value:this.clean(p.get("value"))
    };
    return {
      raw,
      q1:this.mapFuel(raw.fuel),
      q2:this.mapGasSize(raw.gasSize) || this.mapMultiSize(raw.multiSize),
      q3:this.mapUse(raw.use),
      q4:"",
      q5:this.mapValue(raw.value)
    };
  },

  ruleMatches(rule,state) {
    const matches=(allowed,actual)=>!allowed.length || allowed.includes(actual);
    return matches(rule.q1,state.q1)
      && matches(rule.q2,state.q2)
      && matches(rule.q3,state.q3)
      && matches(rule.q4,state.q4)
      && matches(rule.q5,state.q5);
  },

  findRule(state) {
    return window.OONI_RESULTS_CONFIG.rules
      .filter(r=>this.ruleMatches(r,state))
      .sort((a,b)=>(b.priority||0)-(a.priority||0))[0] || null;
  },

  product(handle) {
    const base=window.OONI_RESULTS_CONFIG.products[handle] || {
      title:handle,
      url:`/products/${handle}`,
      description:"",
      image:"",
      price:""
    };

    const local=this.localProducts[handle];
    let image=base.image || "";
    let price=base.price || "";
    let variantId="";
    let galleryImages=[];

    if (local) {
      image = local.featured_image || local.images?.[0] || image;
      galleryImages = Array.isArray(local.images) ? local.images.filter(Boolean) : [];
      if (local.variants?.length) {
        const v=local.variants.find(x=>x.available) || local.variants[0];
        variantId=String(v?.id || "");
        if (typeof v?.price === "number") price=`$${(v.price/100).toFixed(2)}`;
      }
    }

    if (!galleryImages.length) {
      galleryImages = [base.heroImage, base.image].filter(Boolean);
    }

    const primaryHero = base.heroImage || image || galleryImages[0] || "";

    galleryImages = Array.from(new Set([primaryHero, ...galleryImages].filter(Boolean))).slice(0, 6);

    return {
      ...base,
      url:`/products/${handle}`,
      image,
      heroImage: primaryHero,
      galleryImages,
      price,
      variantId
    };
  },

  async hydrateLocalProducts(handles) {
    await Promise.all(handles.map(async handle=>{
      try {
        const res=await fetch(`/products/${handle}.js`,{headers:{"Accept":"application/json"}});
        if (!res.ok) return;
        this.localProducts[handle]=await res.json();
      } catch(e) {}
    }));
  },

  badges(state) {
    const labels = [];
    if(state.raw.fuel) labels.push(this.shortFuel(state.raw.fuel));
    if(state.raw.gasSize || state.raw.multiSize) labels.push(this.shortSize(state.raw.gasSize || state.raw.multiSize));
    if(state.raw.cook) {
      const c=this.lower(state.raw.cook);
      labels.push(c.includes("pizza plus") ? "Pizza + more" : c.includes("mostly pizza") ? "Mostly pizza" : state.raw.cook);
    }
    if(state.raw.use) labels.push(this.shortUse(state.raw.use));
    if(state.raw.value) labels.push(this.shortValue(state.raw.value));
    return labels.filter(Boolean).slice(0,5);
  },

  whyCards(state) {
    const fuel=state.raw.fuel || "Your preferred fuel";
    const size=state.raw.gasSize || state.raw.multiSize || "Your preferred size";
    const value=state.raw.value || "Your feature preference";
    return [
      ["How you want to fire it up", fuel, "Fuel type is one of the strongest filters in your oven match."],
      ["The cooking space you want", size, "Your preferred oven size narrows the Ooni family that fits best."],
      ["Your price + feature balance", value, "This helps decide whether your strongest match is the oven itself or a more complete bundle."]
    ];
  },

  resultCopy(rule,state) {
    const primary=this.product(rule.products[0]);
    const fuel=this.lower(state.raw.fuel);
    const size=state.raw.gasSize || state.raw.multiSize;
    let heading=`Meet your Ooni match: ${this.mainDisplayTitle(primary.title)}`;
    let intro=`Your answers point to ${primary.title} as the strongest fit for the way you want to cook.`;
    if (fuel.includes("both") || fuel.includes("flexibility")) {
      intro=`You want fuel flexibility, and ${primary.title} is the strongest match after balancing your size, setup and feature preferences.`;
    } else if (fuel.includes("wood") || fuel.includes("charcoal")) {
      intro=`You want the live-fire experience, and ${primary.title} is the strongest match after balancing size, setup and features.`;
    } else if (fuel.includes("gas")) {
      intro=`You want quick, controllable gas cooking, and ${primary.title} is the strongest match for your preferred size and feature level.`;
    }
    return {heading,intro,size};
  },

  renderBadges(state) {
    const el=document.getElementById("ooni-result-badges");
    if (!el) return;
    el.innerHTML=this.badges(state).map(x=>`<li>${x}</li>`).join("");
  },

  renderWhy(state) {
    const el=document.getElementById("ooni-why-grid");
    if (!el) return;
    el.innerHTML=this.whyCards(state).map(([eyebrow,title,copy])=>`
      <article class="ooni-why__card">
        <span>${eyebrow}</span>
        <h3>${title}</h3>
        <p>${copy}</p>
      </article>`).join("");
  },

  compactAnswer(value) {
    return (value || "").replace(/\s+/g, " ").trim();
  },

  answerSummary(state) {
    const bits = [];
    if (state.raw.fuel) bits.push(this.compactAnswer(state.raw.fuel).replace(/\s+—.*$/, ""));
    if (state.raw.gasSize || state.raw.multiSize) bits.push(this.compactAnswer(state.raw.gasSize || state.raw.multiSize).replace(/\s+—.*$/, ""));
    if (state.raw.use) bits.push(this.compactAnswer(state.raw.use).replace(/\s+—.*$/, ""));
    if (state.raw.value) bits.push(this.compactAnswer(state.raw.value).replace(/\s+—.*$/, ""));
    return bits.filter(Boolean).slice(0, 4);
  },

  alternativeLabel(primary, candidate, index) {
    const pt = (primary.title || "").toLowerCase();
    const ct = (candidate.title || "").toLowerCase();

    if (index === 1) {
      if (ct.includes("essentials")) return "Simpler setup";
      if (ct.includes("oven") && !ct.includes("bundle")) return "Oven only";
      if (ct.includes("ultimate")) return "More complete setup";
      if (ct.includes("rotating stone")) return "Performance upgrade";
      return "Next-best match";
    }

    if (ct.includes("oven") && !ct.includes("bundle")) return "Oven only";
    if (ct.includes("essentials")) return "Simpler setup";
    if (ct.includes("ultimate")) return "More complete setup";
    if (ct.includes("rotating stone")) return "Performance upgrade";
    return "Also worth considering";
  },

  alternativeReason(primary, candidate, index) {
    const ct = (candidate.title || "").toLowerCase();
    if (ct.includes("essentials")) {
      return "Same oven family, with a simpler set of included accessories.";
    }
    if (ct.includes("oven") && !ct.includes("bundle")) {
      return "Best if you already have the accessories you need.";
    }
    if (ct.includes("ultimate")) {
      return "More of the setup included in one package.";
    }
    if (ct.includes("rotating stone")) {
      return "A more premium setup with added cooking convenience.";
    }
    return index === 1
      ? "A strong alternative if you want a slightly different balance of included gear and value."
      : "Another relevant option from the same recommendation path.";
  },

  renderAnswerSummary(state) {
    const el = document.getElementById("ooni-answer-summary");
    if (!el) return;
    const bits = this.answerSummary(state);
    if (!bits.length) {
      el.hidden = true;
      return;
    }
    el.hidden = false;
    el.textContent = `You told us: ${bits.join(" • ")}`;
  },

  shortFuel(value) {
    const v=this.lower(value);
    if(v.includes("wood") || v.includes("charcoal")) return "Wood / charcoal";
    if(v.includes("both") || v.includes("flexibility")) return "Multi-fuel";
    if(v.includes("gas")) return "Gas";
    return value || "—";
  },

  shortSize(value) {
    const v=this.lower(value);
    if(v.includes("12")) return "12–14″";
    if(v.includes("16")) return "16″";
    if(v.includes("20") || v.includes("multiple pizzas")) return "20″+";
    return value || "—";
  },

  shortUse(value) {
    const v=this.lower(value);
    if(v.includes("trip") || v.includes("camp")) return "Portable / travel";
    if(v.includes("move it around") || v.includes("patio") || v.includes("deck") || v.includes("backyard")) return "Flexible home setup";
    if(v.includes("dedicated outdoor") || v.includes("larger outdoor")) return "Fixed outdoor setup";
    if(v.includes("one spot")) return "Fixed home setup";
    return value || "—";
  },

  shortValue(value) {
    const v=this.lower(value);
    if(v.includes("simple") || v.includes("value")) return "Value-focused";
    if(v.includes("newer performance") || v.includes("convenience") || v.includes("spend more")) return "Balanced";
    if(v.includes("premium") || v.includes("maximum")) return "Premium";
    return value || "—";
  },

  renderSpecStrip(state, rule) {
    const el = document.getElementById("ooni-spec-strip");
    if (!el) return;

    const primary = this.product(rule.products[0]);
    const fuel = this.shortFuel(state.raw.fuel);
    const size = this.shortSize(state.raw.gasSize || state.raw.multiSize);
    const use = this.shortUse(state.raw.use);
    const value = this.shortValue(state.raw.value);
    const setup = /bundle/i.test(primary.title) ? "Bundle" : "Oven only";

    const specs = [
      ["Fuel", fuel],
      ["Cooking space", size],
      ["Where you'll use it", use],
      ["Setup", setup],
      ["Price + features", value]
    ];

    el.innerHTML = specs.map(([label, value]) => `
      <div class="ooni-spec-strip__item">
        <span>${label}</span>
        <strong>${value}</strong>
      </div>
    `).join("");
  },

  renderWhyThisOne(rule, state) {
    const el = document.getElementById("ooni-why-this-one");
    if (!el) return;

    const primary = this.product(rule.products[0]);
    const second = this.product(rule.products[1]);
    const third = this.product(rule.products[2]);

    const rows = [
      {
        label:"Best match",
        title:primary.title,
        copy:"Best overall fit for your fuel, size and feature choices."
      },
      {
        label:this.alternativeLabel(primary, second, 1),
        title:second.title,
        copy:this.alternativeReason(primary, second, 1)
      },
      {
        label:this.alternativeLabel(primary, third, 2),
        title:third.title,
        copy:this.alternativeReason(primary, third, 2)
      }
    ];

    el.innerHTML = rows.map(r => `
      <div class="ooni-choice-row">
        <span>${r.label}</span>
        <div>
          <strong>${r.title}</strong>
          <p>${r.copy}</p>
        </div>
      </div>
    `).join("");
  },

  displayTitle(title) {
    if (!title) return "";
    return title
      .replace(/\s*-\s*2nd Generation$/i,"")
      .replace(/\s*-\s*2nd generation$/i,"")
      .replace(/\s*Pizza Oven$/i,"")
      .replace(/\s*Multi-Fuel$/i,"");
  },

  displaySubtitle(title) {
    if (!title) return "";
    if (/Multi-Fuel Pizza Oven/i.test(title)) return "Multi-Fuel Pizza Oven · 2nd Generation";
    if (/Gas Powered Pizza Oven/i.test(title)) return "Gas Powered Pizza Oven";
    return "";
  },

  renderProducts(rule) {
    const el=document.getElementById("ooni-products-grid");
    if (!el) return;
    const primary=this.product(rule.products[0]);
    const roles=rule.products.map((handle,i)=>{
      if(i===0) return "Best match";
      return this.alternativeLabel(primary,this.product(handle),i);
    });
    el.innerHTML=rule.products.map((handle,i)=>{
      const p=this.product(handle);
      const image=p.image
        ? `<img src="${p.image}" alt="${p.title}" loading="lazy">`
        : `<div class="ooni-product__placeholder">OONI</div>`;
      const canAdd=/^\d+$/.test(p.variantId);
      const action=canAdd
        ? `<button type="button" class="ooni-product__add" data-add="${p.variantId}">Add to cart</button>`
        : `<a href="${p.url}" target="_blank" rel="noopener">View product</a>`;
      return `
        <article class="ooni-product">
          <a class="ooni-product__visual" href="${p.url}" target="_blank" rel="noopener">${image}</a>
          <div class="ooni-product__body">
            <p class="ooni-product__role">${roles[i]}</p>
            <h3 title="${p.title}">${this.displayTitle(p.title)}</h3>
            ${this.displaySubtitle(p.title) ? `<p class="ooni-product__subtitle">${this.displaySubtitle(p.title)}</p>` : ""}
            <p>${p.description || "Selected from your quiz answers."}</p>
            <div class="ooni-product__footer">
              <span>${p.price || ""}</span>
              ${action}
            </div>
          </div>
        </article>`;
    }).join("");

    el.querySelectorAll("[data-add]").forEach(btn=>{
      btn.addEventListener("click",()=>this.addToCart(btn.dataset.add,btn));
    });
  },

  mainDisplayTitle(title) {
    if (!title) return "";
    return title
      .replace(/\s+Gas Powered Pizza Oven\s*-\s*1st Generation$/i,"")
      .replace(/\s+Gas Powered Pizza Oven\s*-\s*2nd Generation$/i,"")
      .replace(/\s+Multi-Fuel Pizza Oven\s*-\s*1st Generation$/i,"")
      .replace(/\s+Multi-Fuel Pizza Oven\s*-\s*2nd Generation$/i,"")
      .replace(/\s*-\s*1st Generation$/i,"")
      .replace(/\s*-\s*2nd Generation$/i,"");
  },

  mainDisplaySubtitle(title) {
    if (!title) return "";
    const t=title.toLowerCase();
    if (t.includes("gas powered pizza oven") && t.includes("1st generation")) return 'Gas Powered Outdoor Pizza Oven · 1st Generation';
    if (t.includes("gas powered pizza oven") && t.includes("2nd generation")) return 'Gas Powered Outdoor Pizza Oven · 2nd Generation';
    if (t.includes("multi-fuel pizza oven") && t.includes("1st generation")) return 'Multi-Fuel Outdoor Pizza Oven · 1st Generation';
    if (t.includes("multi-fuel pizza oven") && t.includes("2nd generation")) return 'Multi-Fuel Outdoor Pizza Oven · 2nd Generation';
    if (t.includes("ultimate bundle")) return 'Complete oven bundle';
    if (t.includes("essentials bundle")) return 'Essentials bundle';
    return "";
  },


  renderHeroGallery(product) {
    const stage = document.getElementById("ooni-primary-image");
    const placeholder = document.getElementById("ooni-primary-placeholder");
    const thumbs = document.getElementById("ooni-primary-thumbs");
    if (!stage || !placeholder || !thumbs) return;

    const images = (product.galleryImages && product.galleryImages.length)
      ? product.galleryImages
      : [product.heroImage || product.image].filter(Boolean);

    if (!images.length) {
      stage.hidden = true;
      placeholder.hidden = false;
      thumbs.hidden = true;
      thumbs.innerHTML = "";
      return;
    }

    placeholder.hidden = true;
    stage.hidden = false;
    stage.src = images[0];
    stage.alt = product.title || "";
    thumbs.hidden = images.length <= 1;
    thumbs.innerHTML = images.map((src, index) => `
      <button
        type="button"
        class="ooni-thumb ${index === 0 ? "is-active" : ""}"
        data-hero-thumb="${index}"
        aria-label="View image ${index + 1} of ${images.length}"
        aria-pressed="${index === 0 ? "true" : "false"}"
      >
        <img src="${src}" alt="" loading="lazy">
      </button>
    `).join("");

    thumbs.querySelectorAll("[data-hero-thumb]").forEach((btn, index) => {
      btn.addEventListener("click", () => {
        stage.src = images[index];
        thumbs.querySelectorAll(".ooni-thumb").forEach((el, i) => {
          el.classList.toggle("is-active", i === index);
          el.setAttribute("aria-pressed", i === index ? "true" : "false");
        });
      });
    });
  },

  renderHero(rule,state) {
    const primary=this.product(rule.products[0]);
    const secondary=this.product(rule.products[1]);
    const third=this.product(rule.products[2]);
    const copy=this.resultCopy(rule,state);

    document.getElementById("ooni-result-heading").textContent=copy.heading;
    document.getElementById("ooni-result-intro").textContent=copy.intro;
    document.getElementById("ooni-summary-title").textContent=primary.title;
    document.getElementById("ooni-summary-copy").textContent="The oven setup that best fits how you want to cook, entertain and fire things up.";
    document.getElementById("ooni-primary-title").textContent=this.mainDisplayTitle(primary.title);
    const primarySubtitle=document.getElementById("ooni-primary-subtitle");
    if(primarySubtitle){
      const subtitle=this.mainDisplaySubtitle(primary.title);
      primarySubtitle.textContent=subtitle;
      primarySubtitle.hidden=!subtitle;
    }
    document.getElementById("ooni-primary-description").textContent=primary.description;
    document.getElementById("ooni-primary-reason").textContent=`This came out on top for your ${state.raw.fuel || "fuel preference"} and ${copy.size || "preferred cooking setup"}, while balancing the amount of kit you want included.`;

    const priceEl=document.getElementById("ooni-primary-price");
    const priceNote=document.getElementById("ooni-primary-price-note");
    if(priceEl){
      priceEl.textContent=primary.price || "";
      priceEl.hidden=!primary.price;
    }
    if(priceNote){
      priceNote.textContent=/bundle/i.test(primary.title) ? "Includes the full recommended bundle" : "Recommended oven";
      priceNote.hidden=!primary.price;
    }

    this.renderHeroGallery(primary);

    document.getElementById("ooni-match-list").innerHTML=`
      <li><strong>Top match:</strong> ${primary.title}</li>
      <li><strong>Next-best:</strong> ${secondary.title}</li>
      <li><strong>Also consider:</strong> ${third.title}</li>`;

    const cta=document.getElementById("ooni-primary-cta");
    if (/^\d+$/.test(primary.variantId)) {
      cta.textContent=/bundle/i.test(primary.title) ? "Add recommended bundle" : "Add recommended oven";
      cta.href="#";
      cta.onclick=(e)=>{e.preventDefault(); this.addToCart(primary.variantId,cta);};
    } else {
      cta.textContent=/bundle/i.test(primary.title) ? "View recommended bundle" : "View recommended oven";
      cta.href=primary.url;
      cta.target="_blank";
      cta.rel="noopener";
    }
  },

  comparisonGroups(products) {
    const groups = [
      {
        label: "The basics",
        rows: ["Setup", "Fuel", "Cooking surface", "Pizza capacity", "Weight", "Best for"]
      },
      {
        label: "Performance",
        rows: ["Max temperature", "Heat-up time", "Key technology", "Rotating stone"]
      },
      {
        label: "Convenience",
        rows: ["Smart features", "Viewing door", "Gas burner", "Cleaning", "Generation", "What's included"]
      }
    ];

    return groups
      .map(group => ({
        ...group,
        rows: group.rows.filter(label =>
          products.some(p => p.comparisonSpecs && p.comparisonSpecs[label])
        )
      }))
      .filter(group => group.rows.length);
  },

  renderComparison(rule) {
    const body = document.getElementById("ooni-comparison-body");
    if (!body) return;

    const products = rule.products.map(handle => this.product(handle));
    const roles = ["Best match", "Next-best match", "Also consider"];
    const groups = this.comparisonGroups(products);

    const productHeaders = products.map((p, index) => `
      <th scope="col" class="${index === 0 ? "is-best" : ""}">
        <div class="ooni-compare-product">
          <span class="ooni-compare-role">${roles[index]}</span>
          ${p.image ? `<img src="${p.image}" alt="" loading="lazy">` : ""}
          <strong>${this.displayTitle(p.title)}</strong>
          ${this.displaySubtitle(p.title) ? `<small>${this.displaySubtitle(p.title)}</small>` : ""}
          <span class="ooni-compare-price">${p.price || ""}</span>
        </div>
      </th>
    `).join("");

    const groupedRows = groups.map(group => `
      <tr class="ooni-comparison-table__section">
        <th colspan="4">${group.label}</th>
      </tr>
      ${group.rows.map(label => `
        <tr>
          <th scope="row">${label}</th>
          ${products.map((p, index) => {
            const value = p.comparisonSpecs?.[label] || "—";
            return `<td class="${index === 0 ? "is-best" : ""}">${value}</td>`;
          }).join("")}
        </tr>
      `).join("")}
    `).join("");

    body.innerHTML = `
      <div class="ooni-comparison__scroll">
        <table class="ooni-comparison-table">
          <thead>
            <tr>
              <th scope="col" class="ooni-comparison-table__label">Compare</th>
              ${productHeaders}
            </tr>
          </thead>
          <tbody>
            <tr class="ooni-comparison-table__price-row">
              <th scope="row">Price</th>
              ${products.map((p, index) => `<td class="${index === 0 ? "is-best" : ""}">${p.price || "—"}</td>`).join("")}
            </tr>
            ${groupedRows}
          </tbody>
        </table>
      </div>
      <p class="ooni-comparison__note">Specs shown here are pulled from the product information available in this store. A dash means the source product data did not provide that detail.</p>
    `;
  },

  openComparison() {
    const panel = document.getElementById("ooni-comparison-panel");
    const toggle = document.getElementById("ooni-comparison-toggle");
    if (!panel || !toggle) return;

    panel.hidden = false;
    toggle.textContent = "Close comparison";
    toggle.setAttribute("aria-expanded", "true");

    requestAnimationFrame(() => {
      panel.classList.add("is-open");
      panel.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  },

  closeComparison() {
    const panel = document.getElementById("ooni-comparison-panel");
    const toggle = document.getElementById("ooni-comparison-toggle");
    if (!panel || !toggle) return;

    panel.classList.remove("is-open");
    toggle.textContent = "Compare recommendations";
    toggle.setAttribute("aria-expanded", "false");

    setTimeout(() => {
      panel.hidden = true;
    }, 220);
  },

  setupComparison(rule) {
    const toggle = document.getElementById("ooni-comparison-toggle");
    const panel = document.getElementById("ooni-comparison-panel");
    if (!toggle || !panel || !rule) return;

    this.renderComparison(rule);

    toggle.addEventListener("click", () => {
      if (panel.hidden) this.openComparison();
      else this.closeComparison();
    });
  },

  async addToCart(variantId,button) {
    const original=button.textContent;
    button.disabled=true; button.textContent="Adding…";
    try {
      const res=await fetch("/cart/add.js",{
        method:"POST",
        headers:{"Content-Type":"application/json","Accept":"application/json"},
        body:JSON.stringify({items:[{id:Number(variantId),quantity:1}]})
      });
      if(!res.ok) throw new Error("Unable to add this item.");
      button.textContent="Added ✓";
      window.dispatchEvent(new CustomEvent("cart:refresh"));
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh"));
      setTimeout(()=>{button.disabled=false;button.textContent=original;},1400);
    } catch(e) {
      console.error(e); button.disabled=false; button.textContent="Try again";
    }
  },

  renderNoMatch(state) {
    document.getElementById("ooni-result-heading").textContent="Your Ooni match is almost ready.";
    document.getElementById("ooni-result-intro").textContent="The page received your quiz answers, but they did not line up with one of the 30 active recommendation rules in the supplied source-of-truth workbook.";
    document.getElementById("ooni-summary-title").textContent="Check the quiz URL";
    document.getElementById("ooni-summary-copy").textContent="Use debug mode to inspect the normalized answers.";
    document.getElementById("ooni-primary-title").textContent="No rule matched";
    document.getElementById("ooni-primary-description").textContent="This usually means a placeholder or answer label differs from the source-of-truth mapping.";
    document.getElementById("ooni-products-grid").innerHTML="";
  },

  updateDebug(state,rule) {
    const out=document.getElementById("ooni-debug-output");
    if(out) out.textContent=JSON.stringify({state,rule},null,2);
  },

  setupDebug() {
    const p=new URLSearchParams(location.search);
    const panel=document.getElementById("ooni-debug");
    if(panel && p.get("debug")==="1") panel.hidden=false;
  },

  async init() {
    const state=this.getState();
    const rule=this.findRule(state);

    const handles=rule ? rule.products.filter(Boolean) : [];
    await this.hydrateLocalProducts(handles);

    this.renderBadges(state);
    this.renderAnswerSummary(state);
    this.renderWhy(state);
    if(rule){
      this.renderHero(rule,state);
      this.renderSpecStrip(state,rule);
      this.renderWhyThisOne(rule,state);
      this.renderProducts(rule);
      this.setupComparison(rule);
    } else {
      this.renderNoMatch(state);
    }
    this.setupDebug();
    this.updateDebug(state,rule);
    console.log("OONI QUIZ RESULT",{state,rule});
  }
};

document.addEventListener("DOMContentLoaded",()=>{
  if(!window.OONI_RESULTS_CONFIG){console.error("OONI_RESULTS_CONFIG missing");return;}
  window.OoniQuizResults.init();
});
